module.exports = __webpack_public_path__ + "static/media/backRightArrow.9360c1b8.svg";